const reducer = () => {
    return (
        null
    )
}

export default reducer